import React from "react";
import { RetailersFilterData } from "@apollo/ops";
import { Controller, useForm } from "react-hook-form";
import { Button } from "@ui/Button";
import { AllRetailersAutocomplete } from "@components/Retailer/RetailerAutocomplete/RetailerAutocomplete";
import { RegionsDropdown } from "@components/Region/RegionsDropdown";

export type FilterData = RetailersFilterData;

type AdminRetailersFilterProps = {
  onFilter: (data: FilterData) => void | Promise<void>;
  defaultValues?: Partial<FilterData>;
  submitText?: string;
};

export function AdminRetailersFilter({
  onFilter,
  defaultValues,
}: AdminRetailersFilterProps) {
  const {
    handleSubmit,
    formState: { errors, isSubmitting },
    control,
  } = useForm<FilterData>({
    defaultValues,
  });

  const wrappedOnSubmit = async (formData: FilterData) => {
    try {
      await onFilter(formData);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <form onSubmit={handleSubmit(wrappedOnSubmit)} autoComplete="off">
      <div className="grid laptop:grid-cols-3 gap-3 items-end">
        <div>
          <Controller
            name="retailerId"
            control={control}
            render={({ field: { onChange, onBlur, value } }) => (
              <AllRetailersAutocomplete
                label=""
                onSelect={onChange}
                onBlur={onBlur}
                selectedId={value}
                error={errors.retailerId?.message}
              />
            )}
          />
        </div>
        <div>
          <Controller
            name="regionId"
            control={control}
            render={({ field: { onChange, value } }) => (
              <RegionsDropdown onChange={onChange} value={value} />
            )}
          />
        </div>
        <div>
          <Button type="submit" disabled={isSubmitting} kind="secondary">
            Filter
          </Button>
        </div>
      </div>
    </form>
  );
}
